package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.replacePathParams

/** `GET /api/v1/billing/prices`: the plan prices; needs no authorization. */
class WMPlanPricesRequestBuilder: FSRequestBuilder<WMPlanPricesRequestBuilder, Nothing>() {

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Get)
        replacePathParams("api", "v1", "billing", "prices")
        acceptJson()
        return super.build()
    }

    override fun self(): WMPlanPricesRequestBuilder = this
}
